import NavigationMapAPI from 'api/navigation-map.api';
import { BaseHandler } from './base.handler';
import {
  type NotificationState,
  showNotification,
} from 'store/notification.slice';
import {
  setNavigationConfigData,
  setNavigationConfigLoading,
} from 'store/navigation-config.slice';
import { type INavigationConfigDBItem } from 'views/Settings/NavigationMap/types/types';

export default class NavigationMapHandler extends BaseHandler {
  private readonly api: NavigationMapAPI;
  constructor() {
    super();

    this.api = new NavigationMapAPI();
  }

  // get naviationConfig
  async getNavigationMap(updateRedux: boolean, customerCode?: string) {
    try {
      const params = customerCode ? { customerCode } : {};
      const response = await this.api.getNavigationMap(params);
      if (updateRedux) {
        this.dispatch(setNavigationConfigData(response));
      }
      return response;
    } catch (_) {
      if (updateRedux) {
        this.dispatch(setNavigationConfigData([]));
      }
      this.handleError(
        'An error occurred while getting the config for customer'
      );
      return [];
    } finally {
      if (updateRedux) {
        this.dispatch(setNavigationConfigLoading(false));
      }
    }
  }

  // create
  async createNavigationMap(
    customerCode: string,
    data: INavigationConfigDBItem[]
  ) {
    try {
      const response = await this.api.createNavigationMap({
        customerCode,
        data,
      });
      const notificationPayload: NotificationState = {
        isLoading: false,
        message: 'Config updated successfully!',
        show: true,
        type: 'success',
      };
      this.dispatch(showNotification(notificationPayload));
      return response;
    } catch (error: any) {
      const errorMsg =
        error?.response?.data?.message ??
        'Error while updating config, pls try again';
      const notificationPayload: NotificationState = {
        isLoading: false,
        message: errorMsg,
        show: true,
        type: 'error',
      };
      this.dispatch(showNotification(notificationPayload));
      this.handleError(
        'An error occurred while creating nav config the customer.'
      );
      throw new Error(errorMsg);
    }
  }
}
